/* eslint-disable @typescript-eslint/no-redeclare */
export const SET_MODAL = 'SET_MODAL'
export type SET_MODAL = typeof SET_MODAL

export const UNSET_MODAL = 'UNSET_MODAL'
export type UNSET_MODAL = typeof UNSET_MODAL

export const CONFIRM_MODAL = 'CONFIRM_MODAL'
export type CONFIRM_MODAL = typeof CONFIRM_MODAL

export const DISABLE_TRADE_CONTROLS = 'DISABLE_TRADE_CONTROLS'
export type DISABLE_TRADE_CONTROLS = typeof DISABLE_TRADE_CONTROLS

export const ENABLE_TRADE_CONTROLS = 'ENABLE_TRADE_CONTROLS'
export type ENABLE_TRADE_CONTROLS = typeof ENABLE_TRADE_CONTROLS
